export default __webpack_public_path__ + "static/media/magic-wand.5d4b82d2.svg";